import React from 'react';
import Ach1 from '../../../../assets/images/achivements/Ach1.jpg';
// import Ach1 from './image/Ach1.jpg';
import Ach3 from '../../../../assets/images/achivements/Ach3.jpg';
import Ach4 from '../../../../assets/images/achivements/Ach4.jpg';
import Ach6 from '../../../../assets/images/achivements/Ach6.jpg';
import Ach8 from '../../../../assets/images/achivements/ach8.jpg';
import Ach7 from '../../../../assets/images/achivements/Ach7.jpg';
import Ach9 from '../../../../assets/images/achivements/ach9.jpg';
import Ach10 from '../../../../assets/images/achivements/ach10.jpg';
import Ach11 from '../../../../assets/images/achivements/ach11.jpg';
import Ach12 from '../../../../assets/images/achivements/ach12.jpg';
import Ach13 from '../../../../assets/images/achivements/ach13.jpg';
import SEO from '../../../common/SEO';

// Achievements data
const achievementsData = [
  { title: 'Lopifit cycle Designing', imgSrc: Ach1, link: '' },
  { imgSrc: Ach3 },
  { title: 'Automatic Hand Washing Station', imgSrc: Ach4, link: '' },
  { imgSrc: Ach6 },
  {
    title: 'Paper in Medical Forensic Science',
    imgSrc: Ach8,
    link: 'https://www.sciencedirect.com/science/article/abs/pii/S0379073824002391',
  },
  { imgSrc: Ach7 },
  { title: 'Recognized by AIIMS Bhopal', imgSrc: Ach9, link: '' },
  { title: 'Recognition in NIT Council', imgSrc: Ach10, link: '' },
  { title: 'Recognised By MANIT Bhopal', imgSrc: Ach11, link: '' },
  {
    title: 'Paper in JERT on Renewable Energy',
    imgSrc: Ach12,
    link: 'https://asmedigitalcollection.asme.org/energyresources/article-abstract/146/12/120801/1201804/Downdraft-Gasification-for-Biogas-Production-The?redirectedFrom=fulltext',
  },
  { imgSrc: Ach13 },
];

// Achievement Card component
const AchievementCard = ({ title, imgSrc, link }) => {
  return (
    <div className='rounded-lg p-2 mx-2 transition-transform transform hover:scale-105 flex flex-col items-center w-[220px]'>
      {link ? (
        <a
          href={link}
          target='_blank'
          rel='noopener noreferrer'
          className='flex flex-col justify-center items-center'
        >
          <img
            src={imgSrc}
            alt={title ? `${title} - AEG Research Achievement` : 'Assurance Education Group (AEG Research) Achievement'}
            className='w-72 h-80 rounded-md object-cover' // Consistent width and height for all images
          />
          {title && (
            <h2 className='text-black font-bold text-sm text-center mt-2'>
              {title}
            </h2>
          )}
        </a>
      ) : (
        <div className='flex flex-col justify-center items-center'>
          <img
            src={imgSrc}
            alt={title ? `${title} - AEG Research Achievement` : 'Assurance Education Group (AEG Research) Achievement'}
            className='w-72 h-80 rounded-md object-cover' // Consistent width and height for all images
          />
          {title && (
            <h2 className='text-black font-bold text-sm text-center mt-2'>
              {title}
            </h2>
          )}
        </div>
      )}
    </div>
  );
};

const Achievements = ({ embedded = false }) => {
  const Heading = embedded ? 'h2' : 'h1';
  return (
    <div className='py-8'>
      {!embedded && (
        <SEO
          title="Scientific Research & Thesis Writing Achievements Bhopal"
          description="Discover Assurance Education Group accomplishments in Scientific Research, best thesis writing services in bhopal, Mtech Thesis Writing, and PhD Thesis writing service."
          canonicalPath="/achievements"
          keywords={[
            "best thesis writing services in bhopal",
            "Scientific Research",
            "PhD Thesis writing service and help",
            "Mtech Thesis Writing",
            "Research paper writing and publication",
            "Paper Writing Bhopal"
          ]}
          breadcrumbs={[
            { name: "Home", path: "/" },
            { name: "Achievements", path: "/achievements" }
          ]}
        />
      )}
      {/* Centered Heading */}
      <Heading className='text-center text-4xl font-bold text-gray-800 mb-8'>
        Our Achievements
      </Heading>

      {/* Achievements Scroll Menu */}
      <div className='flex justify-start items-center overflow-x-auto snap-x snap-mandatory space-x-4 pb-4'>
        {achievementsData.map((achievement, index) => (
          <div className='snap-start flex-shrink-0' key={index}>
            <AchievementCard
              title={achievement.title}
              imgSrc={achievement.imgSrc}
              link={achievement.link}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Achievements;
